<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box lite_popup_box_icloudphotos_tips">
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>{{ $t('language.popup.appleTipsPopup.title') }}</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="show = false"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content">
                <div class="plus_tips_icloudphotos_title">{{ $t('language.popup.appleTipsPopup.tipTitle') }}</div>
                <div class="plus_tips_icloudphotos_tip1">{{ $t('language.popup.appleTipsPopup.tip1') }}</div>
                <div class="plus_tips_icloudphotos_tip2">{{ $t('language.popup.appleTipsPopup.tip2') }}</div>
            </div>
            <div class="lite_popup_footer">
                <!-- 复选框 -->
                <el-checkbox class="plus_tips_icloudphotos_check" v-model="checked">{{ $t('language.popup.appleTipsPopup.checkTip') }}</el-checkbox>
                <!-- 按钮 -->
                <button ref="okBtn" @keyup.esc="show = false" @keyup.enter="ok" @click="ok">{{$t('language.common.ok')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            checked: false,
        };
    },
    watch: {
        show(val) {
            if (val) {
                this.$nextTick(() => {
                    this.$refs.okBtn.focus();
                });
            }
        }
    },
    methods: {
        ok() {
            this.show = false
            this.$emit('ok', this.checked);
        },
    }
};
</script>

<style>
/* 弹窗宽度 */
.lite_popup_box.lite_popup_box_icloudphotos_tips {
    width: 500px;
}
.plus_tips_icloudphotos_title {
  font-weight: bold;
  font-size: 14px;
}
.plus_tips_icloudphotos_tip1 {
  margin-top: 15px;
  line-height: 24px;
  font-size: 14px;
}
.plus_tips_icloudphotos_tip2 {
  margin-top: 15px;
  line-height: 24px;
  font-size: 14px;
}
.plus_tips_icloudphotos_check {
  font-size: 14px;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/lite_tips_icloudphotos.vue